import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showResult } from 'infrastructure/hooks/utils';
import dataService from 'services/dataService';

import type { QueryKey } from '@tanstack/react-query';
import type { IRpmPatientActivity } from 'infrastructure/interfaces/i-rpm-patient-activity';

interface MarkAsErroneousDataProps {
  erroneousReason: string;
  readingId: string;
  deviceId: string;
}
interface UnMarkAsErroneousDataProps {
  readingId: string;
  deviceId: string;
}

interface Props {
  getActivityQueryKey: QueryKey;
}

const markAsErroneousFn = async (postData: MarkAsErroneousDataProps) => {
  const url = 'core/patients/readings/mark-as-erroneous';
  const { error, data } = await dataService.createOne<{ updated: boolean }>(
    url,
    postData,
  );
  if (error) {
    showResult(error);
    return false;
  }

  return data;
};

const unMarkAsErroneousFn = async (postData: UnMarkAsErroneousDataProps) => {
  const url = 'core/patients/readings/un-mark-as-erroneous';
  const { error, data } = await dataService.createOne<{ updated: boolean }>(
    url,
    postData,
  );
  if (error) {
    showResult(error);
    return false;
  }

  return data;
};

export const useMarkAsErroneous = ({ getActivityQueryKey }: Props) => {
  const queryClient = useQueryClient();
  const { mutate: markAsErroneous, isLoading: markAsErroneousLoading } =
    useMutation({
      mutationFn: markAsErroneousFn,
      onSuccess() {
        queryClient.invalidateQueries<IRpmPatientActivity>(getActivityQueryKey);
      },
    });

  const { mutate: unMarkAsErroneous, isLoading: unMarkAsErroneousLoading } =
    useMutation({
      mutationFn: unMarkAsErroneousFn,
      onSuccess() {
        queryClient.invalidateQueries<IRpmPatientActivity>(getActivityQueryKey);
      },
    });

  return {
    markAsErroneous,
    unMarkAsErroneous,
    isLoading: markAsErroneousLoading || unMarkAsErroneousLoading,
  };
};
